import { Injectable } from '@angular/core';

import { UtilityService } from '../../shared/services/utility.service';

@Injectable()
export class PwaUtilityService implements UtilityService {

    public isSurfaceDevice(): boolean {
        if (typeof (Windows.System.Profile.SystemManufacturers) !== 'undefined' &&
            typeof (Windows.System.Profile.SystemManufacturers.SystemSupportInfo) !== 'undefined' &&
            typeof (Windows.System.Profile.SystemManufacturers.SystemSupportInfo.localDeviceInfo) !== 'undefined') {
                // For example this could be "Microsoft Corporation"
                const manufacturer = Windows.System.Profile.SystemManufacturers.SystemSupportInfo.localDeviceInfo.systemManufacturer;
                // For example this could be "Surface Book"
                const productName = Windows.System.Profile.SystemManufacturers.SystemSupportInfo.localDeviceInfo.systemProductName;
                if (!!manufacturer && !!productName) {
                    return manufacturer.toLowerCase().indexOf('microsoft') >= 0 && productName.toLowerCase().indexOf('surface') >= 0;
                }
            }
        return false;
    }
}
